<template>
  <div class="list-box">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="费用审批"
    >
      <el-segmented
        v-model="state.params.is_approve"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[
          { Key: 0, Text: '待审批' },
          { Key: 1, Text: '已审批' },
        ]"
        :empty-values="[null, undefined, 0]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        ref="tableDom"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :width="180">
          <template #header>
            <el-tooltip
              content="当步骤状态为待审批状态时，操作人为待操作的人员；反之操作人为已操作的人员"
            >
              <div class="flex items-center gap-x-1 cursor-pointer">
                <div
                  class="c-table-col-header"
                  label1="当前步骤"
                  label2="操作人时间"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <ul class="flex gap-x-1 items-center">
                  <text>
                    {{ row.flowApproveStep?.step_name }}
                  </text>
                  <c_status
                    arrName="Common_Check_Status"
                    :value="row.flowApproveStep?.status"
                    :key="row.flowApproveStep?.status"
                  />
                </ul>
              </template>
              <template #bottom>
                <ul class="flex gap-x-1 items-baseline">
                  <text class="text-gray-600">
                    {{ row.flowApproveStep?.approve_admin_name }}
                  </text>
                  <text class="ml-1">
                    {{ row.flowApproveStep?.approve_department_name }}
                  </text>
                </ul>
                <ul class="flex gap-x-1 items-center">
                  <text v-if="row?.flowApproveStep?.approve_time">
                    {{ row.flowApproveStep?.approve_time }}
                  </text>
                </ul>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :width="300">
          <template #header>
            <div
              class="c-table-col-header"
              label1="费用名称"
              label2="申请单/申请人"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value2="row.meeting?.start_date + ' ~ ' + row.meeting?.end_date"
            >
              <template #top>
                <div
                  class="flex items-center text-green-700 cursor-pointer hover:underline"
                >
                  <strong>{{ row.name }}</strong>
                  <text class="text-xs">
                    {{ "[" + row.number + "]" }}
                  </text>
                </div>
              </template>
              <template #bottom>
                <div class="flex items-center text-gray-400 gap-x-2">
                  <text class="text-gray-600">
                    {{ row?.add_admin_name }}
                  </text>
                  <text>{{ row?.add_department_name }}</text>
                  <text class="ml-1">{{ row?.create_time }} 创建</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="type_name">
          <template #default="{ row }">
            <text>{{
              row.d_office_expense_type_pname +
              " - " +
              row.d_office_expense_type_name
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          label="合计金额"
          prop="amount"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column label="支付渠道" prop="type_name">
          <template #default="{ row }">
            <c_status
              arrName="Office_Expense_Apply_Payment_Method"
              :value="row.payment_method"
              :key="row.payment_method"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="intro"
          label="申请说明"
          :formatter="$tab_TextFormat"
          :min-width="160"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              v-if="row.status == 0"
              type="primary"
              :icon="Select"
              link
              @click.stop="
                delete state.search;
                state.selectId = row.id;
                state.showDetail = true;
              "
              >审批
            </el-button>
            <el-button
              v-else
              type="success"
              :icon="Search"
              link
              @click.stop="
                state.search = true;
                state.selectId = row.id;
                state.showDetail = true;
              "
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="费用审批"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 70%"
  >
    <c_detail
      :id="state.selectId"
      :search="state.search"
      @close="
        state.showDetail = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { officeExpenseApprove_page } from "@/http/bangongfeiyong";

import c_detail from "./Detail";

class InitFormData {
  params = {
    page: 1,
    is_approve: 0,
  };
}

export default {
  components: {
    c_detail,
  },
  props: {
    params: Number,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      officeExpenseApprove_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    return { state, props, onLoad };
  },
};
</script>

<style lang="less" scoped></style>
